import React from 'react'
import { MemberGlobalStyles } from 'spa/member/styles/GlobalStyles'
import { TechLayoutProps } from './types'
import { StyledCommonHeader } from '../../components/Common/Header/styled'
import { StyledCommonFooter } from '../../components/Common/Footer/styled'

export const StyledTechLayout: React.FC = (props: TechLayoutProps) => {
  return (
    <>
      <MemberGlobalStyles />
      <StyledCommonHeader />
      {props.children}
      <StyledCommonFooter />
    </>
  )
}
